import React from 'react';
import { MantineProvider } from '@mantine/core';

import '@fontsource/pangolin';
import '@fontsource-variable/nunito';
import '@mantine/core/styles.css';
import '@mantine/carousel/styles.css';

import './src/styles/global.styl';
import { theme } from './src/theme';
import LenisProvider from './src/providers/LenisProvider';

export const wrapPageElement = ({ element }) => (
    <LenisProvider>
        <MantineProvider theme={theme}>{element}</MantineProvider>
    </LenisProvider>
);

export const onServiceWorkerUpdateReady = () => window.location.reload(true);
